import { FCX, useOutsideClick } from "@datassential/platform-ui-lib";
import './Versatility.scss';
import { useRef, useState } from "react";
import cn from "classnames";

const FoodVersatility: FCX<{
    foodValue: number;
    menuValue: number;
}> = ({
    foodValue,
    menuValue,
}) => {
    const [isInfoShown, setIsInfoShown] = useState(false);
    const containerRef = useRef(null);

    useOutsideClick({
        ref: containerRef,
        callback: () => setIsInfoShown(false),
    });

    return (
        <>
            <div className="FoodVersatility" ref={containerRef}>
                <div className="FoodVersatility__row">
                    <div
                        className="FoodVersatility__title FoodSectionMenu__blur"
                        data-testid="textFoodMenuVersatilityMenuValue"
                    >
                        {menuValue}
                    </div>
                    <div
                        className="FoodVersatility__description"
                        data-testid="textFoodMenuVersatilityMenuLabel"
                    >
                        menu versatility score
                    </div>
                </div>
                <div className="FoodVersatility__row">
                    <div
                        className="FoodVersatility__title FoodSectionMenu__blur"
                        data-testid="textFoodMenuVersatilityFoodValue"
                    >
                        {foodValue}
                    </div>
                    <div
                        className="FoodVersatility__description"
                        data-testid="textFoodMenuVersatilityFoodLabel"
                    >
                        food versatility score
                    </div>
                </div>
                <div className="Widget__footer">
                    <div
                        className="Widget__footer-link"
                        onClick={() => setIsInfoShown(!isInfoShown)}
                        data-testid="buttonFoodMenuVersatilityOpenInfo"
                    >
                        what's this
                    </div>
                </div>
            </div>
            <div
                className={cn("Widget__overlay", !isInfoShown && "is-hidden")}
                style={{ paddingBottom: 8 }}
            >
                <div
                    className="Widget__overlay-header"
                    data-testid="textFoodMenuVersatilityInfoHeader"
                >
                    is measured on a scale from 0 to 100 (with 50 being an item with average versatility).
                </div>
                <div
                    className="Widget__overlay-content"
                    data-testid="textFoodMenuVersatilityInfoContent"
                >
                    <h3>MENU VERSATILITY</h3>
                    indicates whether an item is used in many different cuisines / types of restaurants.

                    <h3>FOOD VERSATILITY</h3>
                    indicates whether an item is used in many different applications / dishes.
                </div>
                <div className="Widget__footer">
                    <div
                        className="Widget__footer-link is-light"
                        data-testid="buttonFoodMenuVersatilityCloseInfo"
                    >
                        okay thanks
                    </div>
                </div>
            </div>
        </>
    );
};

export default FoodVersatility;